import React, {
  useMemo,
  useRef,
  useState,
  useCallback,
  useEffect,
} from "react";
import BreadCrumb from "Common/BreadCrumb";
import { PaginationState } from "@tanstack/react-table";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import {
  MoreHorizontal,
  Eye,
  FileEdit,
  Trash2,
  UploadCloud,
} from "lucide-react";
import { Dropdown } from "Common/Components/Dropdown";
import {
  Download,
  Plus,
  Search,
  Pencil,
  SlidersHorizontal,
} from "lucide-react";
import JoditEditor, { IJoditEditorProps } from "jodit-react";
import HTMLReactParser from "html-react-parser";
import DeleteModal from "Common/DeleteModal";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import _ from "lodash";
import Drawer from "Common/Components/Drawer";
import { X } from "lucide-react";
import { getImageUrl } from "Common/utils/ImageDomain";
import Modal from "Common/Components/Modal";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import PermissionSwitch from "../Common/Components/PermissionLocks/PermissionSwitch";
import { imageUploader } from "Common/utils/imageUploader";
import ImageView from "Common/Components/ImageView/ImageView";
import { showNotification } from "Common/utils/Notification";
import HtmlCode from "Common/Components/HtmlCode/HtmlCode";
import ImageData from "Common/Components/customImage/Image";

const BlogAuthor = () => {
  const [authorData, setAuthorData] = useState([]);
  const [loader, setLoader] = useState<any>(false);
  const [search, setSearch] = useState<any>();
  const [showModel, setShowModel] = useState<boolean>(false);
  const [read, setRead] = useState<any>();
  const defaultToggle = () => setShowModel(!showModel);
  const [imageLink, setImageLink] = useState<any>("");
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [totalItems, setTotalItems] = useState(0);
  const [render, setRender] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>();
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const [content, setContent] = useState<any>("");
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);

  const toggleImage = () => setShowImage(!showImage);

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please select Image", "error");
      }
    }
  }, [imageData]);

  const deleteToggle = () => setDeleteModal(!deleteModal);

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
      permission: profile.permission,
    })
  );

  const { error, success, user, permission } = useSelector(selectProperties);

  interface PermissionInfo {
    permissions: string[];
  }

  const rawPermission = localStorage.getItem("permission");
  const premissionInfo: PermissionInfo | null = rawPermission
  ? JSON.parse(rawPermission)
  : null;

  const debouncedHandler = useCallback(
    _.debounce((user: any, render: any, pagination: any) => {
      return fetchDateWithFilters(user, render, pagination);
    }, 700),
    []
  );
  async function fetchDateWithFilters(
    searchByName: any,
    render: any,
    pagination: any
  ) {
    let filters: { [index: string]: any } = {};
    if (searchByName) {
      filters.qtext = searchByName;
    }

    const localData = await callApi("v1/blog-author/list", "post", {
      pageNum: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      filters,
    });
    let arr = [];
    if (localData?.status === "Success") {
      setAuthorData([...localData.data.blog_authorList]);
      setPageCount(
        Math.ceil(localData.data.blog_authorCount / pagination.pageSize)
      );
      setTotalItems(localData.data.blog_authorCount);
    }
  }

  const filterSearchData = (e: any) => {
    const search = e.target.value;

    setSearch(search);
  };

  useEffect(() => {
    debouncedHandler(search, render, pagination);
  }, [search, render, pagination]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      //dispatch(onDeleteEmployee(eventData.id));

      const res = await callApi(
        `v1/blog-author/${eventData?._id}/update`,
        "post",
        {
          blog_author: { is_deleted: true },
        }
      );
      if (res && res?.status === "Success") {
        setDeleteModal(false);
        setRender(!render);
        toast("Deleted successfully");
      }
    }
  };

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setImageLink(ele);
    setContent(ele?.description);
    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // employeeId: (eventData && eventData.employeeId) || "",
      name: (eventData && eventData.name) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
    }),

    onSubmit: async (values) => {
      if (isEdit) {
        const updateData = {
          _id: eventData ? eventData._id : 0,
          ...values,
        };
        // update user
        if (!!!imageLink?.media_url && !!!imageLink?.profile_url) {
          showNotification("Please add image", "error");
          return;
        }
        if (!content) {
          showNotification("Please add description", "error");
          return;
        }
        try {
          setLoader(true);
          const res = await callApi(
            `v1/blog-author/${eventData?._id}/update`,
            "post",
            {
              blog_author: {
                ...values,
                profile_url: imageLink.media_url,
                description: content,
              },
            }
          );
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            toast("Updated successfully");
            setImageLink("");
            setContent("");
          }
        } catch (e) {
          toast("something went wrong");
        }
      } else {
        if (!!!imageLink?.media_url) {
          showNotification("Please add image", "error");
          return;
        }
        if (!!!content || content === "") {
          showNotification("Please add description", "error");
          return;
        }
        try {
          setLoader(true);
          const res = await callApi(`v1/blog-author/new-blog-author`, "post", {
            blog_author: {
              name: values?.name,
              profile_url: imageLink.media_url,

              description: content,
            },
          });
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            toast("Author created successfully");
            setImageLink("");
            setContent("");
          }
        } catch (e) {
          toast("something went wrong");
        }
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      setImageLink("");
    } else {
      setShow(true);
      setEventData("");
      setImageLink("");
      validation.resetForm();
    }
  }, [show, validation]);

  const authorListColumns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Profile Image",
        accessorKey: "profile_url",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <Link
            to={getImageUrl(cell.row.original.profile_url)}
            className="flex items-center gap-3 "
            target="_blank"
          >
            <div className="rounded-full size-6 shrink-0 bg-slate-100">
              <img
                src={getImageUrl(cell.row.original.profile_url)}
                alt=""
                className="h-6 rounded-full"
              />
            </div>
          </Link>
        ),
      },

      {
        header: "Description",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <Link to="#!" className="flex items-center gap-3">
            <div>
              {HTMLReactParser(
                cell.row.original.description?.slice(0, 30) ?? ""
              )}

              {cell.row.original.description?.length > 30 ? (
                <>
                  {" ..."}
                  <span
                    style={{
                      color: "#fb801d",
                    }}
                    onClick={() => {
                      // setReadText("Text");
                      setRead(cell.row.original.description);
                      defaultToggle();
                    }}
                  >
                    more
                  </span>
                </>
              ) : null}
            </div>
          </Link>
        ),
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <PermissionSwitch
              hasPermissions={premissionInfo?.permissions ?? []}
              shouldHavePermissions={["blogauthor:edit"]}
              yes={
                <Link
                  to="#!"
                  data-modal-target="addEmployeeModal"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    handleUpdateDataClick(data);
                  }}
                >
                  <Pencil className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
            <PermissionSwitch
              hasPermissions={premissionInfo?.permissions ?? []}
              shouldHavePermissions={["blogauthor:delete"]}
              yes={
                <Link
                  to="#!"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    onClickDelete(data);
                  }}
                >
                  <Trash2 className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
          </div>
        ),
      },
    ],
    []
  );

  return (
    <>
      <React.Fragment>
        <BreadCrumb title="Authors" pageTitle="Authors" version="" />
        <DeleteModal
          show={deleteModal}
          onHide={deleteToggle}
          onDelete={handleDelete}
        />
        <ToastContainer closeButton={false} limit={1} />
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">Authors</h6>
                <div className="shrink-0">
                  <PermissionSwitch
                    hasPermissions={premissionInfo?.permissions ?? []}
                    shouldHavePermissions={["blogauthor:create"]}
                    yes={
                      <button
                        type="button"
                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        onClick={toggle}
                      >
                        <Plus className="inline-block size-4" />{" "}
                        <span className="align-middle">Add Authors</span>
                      </button>
                    }
                    no={
                      <button
                        type="button"
                        disabled={true}
                        className="text-grey btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        onClick={null}
                      >
                        <Plus className="inline-block size-4" />{" "}
                        <span className="align-middle">Add Authors</span>
                      </button>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-3">
                    <input
                      type="text"
                      className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Search for name of author...."
                      autoComplete="off"
                      onChange={(e) => filterSearchData(e)}
                    />
                    <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                </div>
              </form>
            </div>
            <div className="card-body">
              <TableContainer
                isPagination={true}
                columns={authorListColumns || []}
                data={authorData || []}
                pageCount={pageCount}
                pagination={pagination}
                totalItems={totalItems}
                onPaginationChange={(updater: any) => {
                  const nextState = updater(pagination);
                  if (nextState.pageIndex !== pagination.pageIndex)
                    setPagination(nextState);
                }}
                divclassName="overflow-x-auto"
                tableclassName="w-full whitespace-nowrap"
                theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              />
            </div>
          </div>
        </div>
        {/* Employee Modal */}
        <Drawer
          show={show}
          onHide={toggle}
          id="drawerEnd"
          drawer-end="true"
          className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
          <Drawer.Header
            className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
            closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <Drawer.Title className="text-15">
              {!!isEdit ? "Edit Author" : "Add Author"}
            </Drawer.Title>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </Drawer.Header>
          <Drawer.Body className="h-full p-4 overflow-y-auto">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Name"
                    name="name"
                    onChange={validation.handleChange}
                    value={validation.values.name || ""}
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <p className="text-red-400">{validation.errors.name}</p>
                  ) : null}
                </div>

                <div className="xl:col-span-12">
                  <HtmlCode
                    content={content}
                    setContent={setContent}
                    label={"Text"}
                  />
                </div>
              </div>
              <div className="m-4 ml-0 xl:col-span-12">
                {imageLink ? (
                  <div className="flex items-center">
                    <ImageData
                      imageLink={imageLink}
                      setImageData={setImageData}
                      setImageLink={setImageLink}
                    />
                    <div className="h-3 ml-3">
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          toggleImage();
                        }}
                        // htmlFor="uploadimage49"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setImageData(undefined);
                        toggleImage();
                      }}
                      //htmlFor="uploadimage59"
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Image"}
                    </div>
                  </>
                )}
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={toggle}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loader}
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  id="addNew"
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : !!isEdit ? (
                    "Update Author"
                  ) : (
                    "Add Author"
                  )}
                </button>
              </div>
            </form>
          </Drawer.Body>
        </Drawer>
        <Drawer
          show={showModel}
          onHide={defaultToggle}
          id="drawerEnd"
          drawer-end="true"
          className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
          <Drawer.Header
            className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
            closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <Drawer.Title className="text-15">{"Text"}</Drawer.Title>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </Drawer.Header>
          <Drawer.Body className="h-full p-4 overflow-y-auto">
            {/* <h5 className="mb-3 text-16">{}</h5> */}
            <div className="mx-4 text-slate-500 dark:text-zink-200">
              {HTMLReactParser(read ?? "")}
            </div>
          </Drawer.Body>
        </Drawer>
        <Drawer
          show={showImage}
          onHide={toggleImage}
          id="drawerEnd"
          drawer-end="true"
          className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
          <Drawer.Header
            className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
            closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </Drawer.Header>
          <Drawer.Body className="h-full p-4 overflow-y-auto">
            <ImageView
              showImage={showImage}
              setEventData={setImageData}
              togleImage={toggleImage}
            />
          </Drawer.Body>
        </Drawer>
      </React.Fragment>
    </>
  );
};

export default BlogAuthor;
